import { render, staticRenderFns } from "./DeleteCustomerModal.vue?vue&type=template&id=b653125c"
import script from "./DeleteCustomerModal.vue?vue&type=script&lang=js"
export * from "./DeleteCustomerModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteCustomerModal.vue?vue&type=style&index=0&id=b653125c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports